import { useParticipantProperty } from '@daily-co/daily-react';
import { extractFirstName } from '../../utils/nameFormatter';
import './Username.css';

export default function Username({ id, isLocal }) {
  const username = useParticipantProperty(id, 'user_name');
  const isOwner = useParticipantProperty(id, 'owner');

  const displayName = username ? extractFirstName(username).firstName : id;

  return (
    <div className="username">
      {displayName} {isLocal && '(you)'} {isOwner && <b>(mod)</b>}
    </div>
  );
}
